import { repositories } from "@/core";
import ListControllerMixin from "@/utils/ListControllerMixin";

export default {
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  mixins: [ListControllerMixin],
  data() {
    return {
      columns: [
        {
          name: "Título",
          sortName: null,
          order: null,
        },
        {
          name: "Criado em",
          sortName: null,
          order: null,
        },
        {
          name: "",
          sortName: null,
          order: null,
        },
      ],
    };
  },

  methods: {
    fetchPromise() {
      return repositories.contentsService.list({
        ...this.filters,
        orderBy: this.columns.filter(
          (r) => r.order != null && r.sortName != null,
        ),
      });
    },
    copyURL(item, index, hyperlink) {
      this.$set(this.items[index], "detail_url_copied", true);
      setTimeout(() => {
        this.$set(this.items[index], "detail_url_copied", false);
      }, 3000);
      this.$helper.copyUrlWithHyperlinkTag(
        `${this.$paths.contents.detail}/${item.id}`,
        hyperlink,
      );
    },
  },
};
